const messages = {
  en: {
    translations: {
      settingsSidebar: {
        title: "Settings",
        notificationsSection: "Notifications",
        enableAll: "Enable all notifications",
        enableSound: "Enable notification sound",
        gestorSection: "Notifications (manager)",
        scopeAll: "Enable notifications for all ACCEPTED conversations",
        scopeMine: "Enable notifications only for my conversations",
        scopeDisabled: "Disable all notifications",
        appearanceSection: "Appearance",
        darkMode: "Dark mode",
        fontSizeMensagens: "Message font size",
        close: "Close",
      },
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          disconnectOficialHint: "Meta channel connections (official WhatsApp, Messenger, Instagram) cannot be disconnected from the system",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          generateQr: "Generate QR Code",
          newDevice: "Pair new device",
          connecting: "Connecting",
          connected: "Connected",
        },
        toolTips: {
          disconnected: {
            title: "WhatsApp disconnected",
            content:
              "The connection dropped unexpectedly. Click 'Try Again' to reconnect using the current pairing.",
          },
          cleanSession: {
            title: "Waiting for pairing",
            content:
              "There is no active session for this connection (it was manually disconnected, logged out from the phone, or the QR Code expired). Click 'Generate QR Code' to pair a device.",
          },
          forbidden: {
            title: "Connection refused by WhatsApp",
            content:
              "WhatsApp refused this connection (usually a banned or temporarily restricted account). Check the number's status on the phone. You can try again later, or use 'Pair new device' to connect a different number.",
          },
          duplicateNumber: {
            title: "Number already connected on another session",
            content:
              "This phone is already paired with another connection in this system. To avoid duplicate messages, this session was automatically disconnected. Use 'Generate QR Code' to pair with a different number, or remove this connection if it is no longer needed.",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          canal: "Channel",
          connectedNumber: "Connected number",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
        title: "Scan to connect",
        connection: "Connection",
        step1: "Open WhatsApp on your phone.",
        step2: "Tap **More options (⋮)** or **Settings** and then **Linked devices**.",
        step3: "Tap **Link a device**.",
        step4: "Point your phone's camera at this QR code.",
        waiting: "Generating the QR code...",
        expires: "The QR code expires in a few seconds and is refreshed automatically.",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
        conversaNaoEncontrada: "Conversation not found.",
        conversaNaoEncontradaDetalhe: "It does not exist or belongs to a connection you cannot access.",
        conversaErroCarregar: "This conversation could not be loaded.",
        conversaTentarNovamente: "Try again",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        titleGroup: "Edit Group Data",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldQueuePlaceholder: "Please select a queue",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "New lead",
        connection: "Connection",
        name: "Contact name",
        number: "Phone number",
        invalidNumber: "Invalid number. Enter with area code (and optionally country code 55).",
        successNew: "Conversation started!",
        infoExisting: "There is already a conversation for this contact on this connection.",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        encaminhada: "Forwarded",
        apagadaPeloCliente: "Message deleted by the customer",
        apagada: "Message deleted",
        header: {
          assignedTo: "Assigned to:",
          connection: "Connection:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        placeholderPending: "Accept this ticket to send a message.",
        signMessage: "Sign",
        audio: {
          permissaoNegada: "The browser blocked the microphone for this site. Click the icon next to the address bar, allow the microphone and reload the page.",
          semMicrofone: "No microphone found. Connect a microphone or headset and try again.",
          microfoneEmUso: "The microphone is being used by another program. Close it and try again.",
          contextoInseguro: "Audio recording only works over a secure connection (https).",
          falhaGravar: "Could not start recording",
          semGravacao: "Nothing was recorded — hold the microphone for a few seconds before sending.",
        },
        midia: {
          tituloVideoGrande: "Video over the limit",
          videoGrande: "The video \"{{nome}}\" is {{tamanho}}. WhatsApp only sends videos up to {{limite}}. Send it as a document? The contact gets a file to download instead of a video playing in the chat.",
          enviarComoDocumento: "Send as document",
          acimaDoTeto: "The file \"{{nome}}\" is {{tamanho}} and WhatsApp does not send anything over {{limite}}. Shrink the file and try again.",
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      forwardMessageModal: {
        title: "Contacts",
        buscar: "Search contacts",
        grupo: "Group",
        semContatos: "No contacts found on this connection.",
        maxContatos: "You can forward to at most {{max}} contacts at a time.",
        sucesso: "Message forwarded to {{total}} contact(s).",
        parcial: "Message forwarded to {{enviados}} of {{total}} contact(s). Check the log for failures.",
        nenhumEnviado: "The message could not be forwarded to any of the selected contacts.",
        buttons: {
          ok: "Forward",
          okContagem: "Forward ({{total}})",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        forward: "Forward",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_MIDIA_MUITO_GRANDE:
          "File too large for WhatsApp. Shrink the file and try again.",
        ERR_MIDIA_UPLOAD:
          "Could not upload the attachment. Please try again.",
        ERR_ENCAMINHAR_SEM_DESTINATARIOS:
          "Select at least one contact to forward the message to.",
        ERR_ENCAMINHAR_MUITOS_DESTINATARIOS:
          "Too many contacts selected for a single forward.",
        ERR_ENCAMINHAR_MENSAGEM_APAGADA:
          "This message was deleted and cannot be forwarded.",
        ERR_ENCAMINHAR_TIPO_LOCAL:
          "This is an internal system message that was never sent to WhatsApp, so it cannot be forwarded.",
        ERR_ENCAMINHAR_SEM_PAYLOAD:
          "This message has no original WhatsApp payload (old or imported message) and cannot be forwarded.",
        ERR_ENCAMINHAR_OFICIAL_NAO_SUPORTADO:
          "Meta Official API connections only allow forwarding text messages sent by you.",
        ERR_ENCAMINHAR_CONTATO_FORA_DO_ESCOPO:
          "You do not have access to this conversation: you can only forward to accepted contacts under your responsibility.",
        ERR_ENCAMINHAR_CONTATO_BLOQUEADO:
          "Blocked contact: the message was not forwarded to them.",
        ERR_MENU_INVALIDO:
          "Invalid menu: it needs between 1 and 10 options, and every section needs a title when there is more than one.",
        ERR_BUTTONS_NOT_SUPPORTED_CANAL:
          "This channel does not support buttons. Send the options as text.",
        ERR_TIPO_NAO_SUPORTADO_CANAL:
          "This message type cannot be sent over Messenger or Instagram.",
        ERR_CANAL_SEM_URL_PUBLICA:
          "The connection has no public address configured: the media could not be sent.",
        ERR_EDIT_LOCAL_MESSAGE:
          "This is an internal system message and cannot be edited on WhatsApp.",
        ERR_EDIT_NOT_SUPPORTED_OFICIAL:
          "Meta Official API connections do not support editing messages.",
        ERR_EDIT_CAPTION_UNAVAILABLE:
          "Could not edit this media's caption. Send the media again with the correct caption.",
        ERR_NO_WAPP_SELECTED:
          "Connection not selected, please select one from the lead screen.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_WAPP_NOT_CONNECTED:
          "The WhatsApp connection is reconnecting. Try again shortly; if it persists, check the connections page.",
        ERR_META_SEND:
          "Error sending via the Meta API.",
        ERR_META_FORA_JANELA:
          "Cannot reply: the customer has not sent a message for over 7 days. The conversation only reopens when they write again.",
        ERR_EXTERNAL_LOGIN:
          "Error in external login.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_BLACKLIST_FORBIDDEN:
          "You don't have permission to manage the blacklist for this connection.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NOME_OBRIGATORIO: "Enter the contact name.",
        ERR_NUMERO_INVALIDO: "Invalid number. Enter with area code (and optionally country code 55).",
        ERR_ERP_NOVO_LEAD: "Failed to create lead in ERP. The conversation was saved as pending.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_MENSAGEM_NAO_ENCONTRADA: "Could not find that message in the conversation.",
        ERR_SEM_PERMISSAO_TICKET:
          "You cannot reply in this conversation. For groups, only users assigned to the group's connection; otherwise, the ticket owner or a manager of the same branch.",
        ERR_TAG_SEM_PERMISSAO:
          "You do not have permission to use or change this label.",
        ERR_TAG_NOT_FOUND:
          "Label not found.",
        ERR_SEM_PERMISSAO_ASSUMIR_LEAD:
          "You do not have permission to take over leads. Ask for the permission in your user registration.",
        ERR_LISTAGEM_SOBRECARREGADA:
          "The system is handling too many requests right now. Wait a few seconds and try again.",
        ERR_AUDIO_RAPIDO_INDISPONIVEL:
          "The audio of this quick answer is no longer available on the server. Please register the quick answer again.",
        ERR_MESSAGE_NOT_FOUND: "Message not found.",
        ERR_REACT_LOCAL_MESSAGE: "This message is internal to the system, it does not exist on WhatsApp.",
        ERR_REACTION_INVALID_EMOJI: "Invalid reaction.",
        ERR_ONLINE_FORA_HORARIO_ACESSO:
          "You are outside your access hours and cannot go online right now.",
        ERR_ONLINE_OFFLINE_ERP:
          "Could not change your online status. Please try again in a moment.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
